import { useMultiplePress } from '@/hooks/use-multiple-press'
import { useDataStore } from '@/lib/machine/use-data-store'
import { WifiIcon, WifiOffIcon } from 'lucide-react'

export const MachineConnectionStatus = () => {
  const isConnected = useDataStore(s => s.isConnected)
  const refreshMetrics = useDataStore(s => s.refreshMetrics)
  const refreshData = useDataStore(s => s.refreshData)
  const devMode = useDataStore(s => s.devMode)
  const setDevMode = useDataStore(s => s.setDevMode)

  const onQuintuplePress = () => setDevMode(!devMode)
  const useMultiplePressProps = useMultiplePress(onQuintuplePress, 5)

  return (
    <div className="flex items-center gap-1 text-md select-none" {...useMultiplePressProps}>
      {isConnected ? (
        <>
          {devMode && (
            <div className="flex gap-2">
              <span className="text-lg">wifi {refreshData?.WIFI}</span>
              <span className="text-lg">delta {refreshMetrics.delta}</span>
            </div>
          )}
          <WifiIcon className="h-5" />
        </>
      ) : (
        <WifiOffIcon className="w-5" />
      )}
    </div>
  )
}
